import TriLoginApi from "./api/TriLoginApi";

async function standardTririgaLogin() {
  let currentUser;
  try {
    currentUser = await TriLoginApi.getCurrentUser();
  } catch (error) {
    currentUser = null;
  }
  if (currentUser == null) {
    TriLoginApi.redirectToTririgaLogin(
      encodeURIComponent(window.location.href)
    );
  }
  return currentUser;
}

export { TriLoginApi, standardTririgaLogin };
